
import { GrantType } from '@/common/permission';
import { format } from 'date-fns';
import { PlanType } from '@/common/permission';
// import { UNLIMITED } from '../config'

export default {
  props: {
    formValue: {
      type: Object,
      required: true
    },
    authorizeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      planList: [],
      effectTime: true
    };
  },

  watch: {
    'formValue.grant_type': function formValueGrant_type(val) {
      if (val === GrantType.Trial) {
        // eslint-disable-next-line vue/no-mutating-props
        this.formValue.days = 7;
      }
    }
  },
  computed: {
    dayOptions: function dayOptions() {
      if (this.formValue.grant_type === GrantType.Trial) {
        return [{
          label: '7天',
          value: 7
        }, {
          label: '14天',
          value: 14
        }, {
          label: '90天',
          value: 90
        }];
      }

      if (this.formValue.type === PlanType.Recharge) {
        return [{
          label: '10年',
          value: 365 * 10
        }];
      }

      return [7, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330, 360, 365].map(function (t) {
        return {
          label: t + '\u5929',
          value: t
        };
      });
    },
    expiredDate: function expiredDate() {
      if (!this.formValue.days) return '';

      var day = this.formValue.days || 0;

      var date = new Date();
      date.setTime(date.getTime() + 3600 * 1000 * 24 * day);
      date = format(date, 'YYYY-MM-DD 23:59:59');
      return date;
    },
    disabled: function disabled() {
      return [PlanType.Recharge].includes(this.formValue.type) || this.formValue.isEdit;
    }
  },
  methods: {}
};